import { WatchQueryFetchPolicy } from '@apollo/client';

import {
  GetHomepageOrderStateDocument,
  useGetHomepageOrderStateQuery,
} from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';
import { client } from 'state/graphql/client';
import AuthStorage from 'utils/cognito/storage';
import { StorageKeys } from 'utils/local-storage';
import logger from 'utils/logger';

export const useGetHomepageOrderState = (
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network',
  skip?: boolean
) => {
  const { isAuthenticated } = useAuthContext();
  const { data, error, loading, refetch } = useGetHomepageOrderStateQuery({
    context: { shouldNotBatch: true },
    skip: !isAuthenticated || skip,
    fetchPolicy,
  });

  return {
    error,
    homepageOrderState: data?.homepageOrderState,
    loading,
    refetch,
  };
};

export async function prefetchHomepageOrderState(): Promise<void> {
  // @authRequired — skip the request entirely for signed-out guests.
  if (!AuthStorage.getItem(StorageKeys.USER_AUTH_TOKEN)) {
    return;
  }
  try {
    await client.query({
      query: GetHomepageOrderStateDocument,
      context: { shouldNotBatch: true },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    });
  } catch (error) {
    // Swallow failures so a slow/failed prefetch never blocks startup.
    // The hook will retry the fetch when the widget mounts.
    logger.warn({ error, message: 'prefetchHomepageOrderState failed' });
  }
}
